<template>
    <div>
        <div class="page-wrapper">
            <div class="page-bg"></div>
            <div class="page-content">
                <TopBarDark
                      :title="lbl.static.contact.title_topbar"
                      @clickBack="clickBack()">
                </TopBarDark>
                <div class="contact-page">
                    <div class="wrapper-contact">
                        <img class="img-contact" :src="`${pictureUrl}`">
                        <div class="text-title-company">
                            {{lbl.static.contact.title_company}}
                        </div>
                        <div class="text-detail-address">
                                {{lbl.static.contact.text_detail_address}}
                        </div>
                        <div class="text-detail">
                            <div class="text-margin">
                                {{lbl.static.contact.tel}}
                            </div>
                            <div class="text-margin">
                                {{lbl.static.contact.email}}
                            </div>
                            <div class="text-margin">
                                {{lbl.static.contact.time}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
  name: "Contact",
  mixins: [AccountMixin, LocaleMixin],
    components: {
        TopBarDark
    },
    data: function() {
        return {
            pictureUrl: Vue.bzbsConfig.bzbsBlobUrl + '/config/bioderma/static/img/img-contact.png',
        }
    },
  
    methods: {
        clickBack: function () {
            this.$router.back();
        },
    }
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import './Contact.scss';
</style>
